import React from 'react';
import {ClinipamIconProps} from './types';

export const ClinipamIcon = ({size}: ClinipamIconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		style={{minWidth: size || 24}}
		height={size}
		width={size}
		viewBox="0 0 48 48"
		fill="none">
		<path
			d="M8.52639 17.6666C7.014 20.2856 8.80599 23.4513 13.3177 25.193C15.6816 26.1084 19.6469 26.2991 22.2269 25.5999C21.5406 23.019 19.4054 19.6753 17.4355 18.0734C13.6736 15.0222 10.0388 15.0476 8.52639 17.6666Z"
			fill="#FF4E05"
		/>
		<path
			d="M23.9926 7C20.7136 7 18.7183 10.3945 19.5317 15.5816C19.9638 18.3023 21.9337 22.1164 23.9926 24.1633C26.0515 22.1164 28.0214 18.2896 28.4535 15.5816C29.2796 10.3945 27.2716 7 23.9926 7Z"
			fill="#FF222B"
		/>
		<path
			d="M39.4739 17.6667C37.9615 15.0478 34.3267 15.0096 30.5648 18.0609C28.5949 19.6628 26.447 22.9937 25.7607 25.5746C28.3407 26.2738 32.306 26.0831 34.6699 25.1804C39.1943 23.4514 40.9863 20.2857 39.4739 17.6667Z"
			fill="#FF4E05"
		/>
		<path
			d="M23.9934 39.0001C26.0142 39.0001 27.247 36.9023 26.7386 33.7112C26.4717 32.033 25.2644 29.681 23.9934 28.4224C22.7225 29.681 21.5152 32.033 21.2483 33.7112C20.7399 36.9023 21.9727 39.0001 23.9934 39.0001Z"
			fill="#FFCC23"
		/>
		<path
			d="M13.0769 32.7576C14.0809 34.5121 16.5084 34.5248 19.0248 32.4906C20.3466 31.4227 21.77 29.1978 22.2275 27.4688C20.4991 26.9983 17.8683 27.1255 16.2796 27.7357C13.2676 28.8927 12.0602 31.0031 13.0769 32.7576Z"
			fill="#FF8800"
		/>
		<path
			d="M34.9113 32.7704C35.9154 31.0286 34.7207 28.9055 31.7086 27.7485C30.1327 27.1383 27.4892 27.0111 25.7607 27.4815C26.2183 29.2106 27.6417 31.4354 28.9634 32.5034C31.4799 34.5376 33.9073 34.5248 34.9113 32.7704Z"
			fill="#FF8800"
		/>
	</svg>
);
